import { HStack, Link, Text, useDisclosure, VStack } from "@chakra-ui/react";
import PrivacyModal from "../Modals/PrivacyModal";
import TermsOfUseModal from "../Modals/TermsOfUseModal";
import { colors } from "../../styles";

export default function Footer() {
    const { isOpen: isTermsOpen, onOpen: onOpenTerms, onClose: onCloseTerms } = useDisclosure();
    const { isOpen: isPrivacyOpen, onOpen: onOpenPrivacy, onClose: onClosePrivacy } = useDisclosure();

    return (
        <>
            <VStack
                spacing={1}
                marginTop={"auto"}
                paddingX={5}
                paddingY={8}
                alignItems={"center"}
            >
                <HStack spacing={2}>
                    <Text
                        as={"button"}
                        fontSize={12}
                        fontWeight={400}
                        color={colors.g2}
                        onClick={onOpenTerms}
                    >
                        이용약관
                    </Text>
                    <Text fontSize={12} color={colors.g3}>·</Text>
                    <Text
                        as={"button"}
                        fontSize={12}
                        fontWeight={400}
                        color={colors.g2}
                        onClick={onOpenPrivacy}
                    >
                        개인정보처리방침
                    </Text>
                </HStack>
                <Text fontSize={12} fontWeight={400} color={colors.g3} textAlign={"center"}>
                    서비스·광고·협업 문의:{" "}
                    <Link href={"mailto:contact@pharm-chat.com"} color={colors.g2}>
                        contact@pharm-chat.com
                    </Link>
                </Text>
                <Text fontSize={12} fontWeight={400} color={colors.g3} textAlign={"center"}>
                    © 2026 (주)더리얼. All rights reserved.
                </Text>
            </VStack>
            <TermsOfUseModal isOpen={isTermsOpen} onClose={onCloseTerms} />
            <PrivacyModal isOpen={isPrivacyOpen} onClose={onClosePrivacy} />
        </>
    );
}
